import React from 'react'
import SimpleAccordion from '../../ui_reusable/SimpleAccordion'
import UniversalLoader from '../../ui_reusable/UniversalLoader'
import { PanelSpecialIndent } from '../../ui_reusable/styles/PlacementMisc.styles'
// Import the generated React Query hook and types
import { useLearningsRetrieve } from '../../../api/generated/endpoints/learning/learning'
// Import Zod schema for runtime validation
import { learningsRetrieveResponse } from '../../../api/generated/validation/learning/learning.zod'
// Import our enhanced validation utility
import { validateAndLog } from '../../../utils/zodDebugger'

const IntroLearningPage: React.FC = () => {
  // Use the generated React Query hook for type-safe API calls
  const {
    data: learningData,
    isLoading,
    isError,
    error,
  } = useLearningsRetrieve({
    query: {
      staleTime: 0,
      gcTime: 0,
    },
  })

  // Runtime validation with enhanced debugging (one-liner)
  const validatedData = validateAndLog(
    learningsRetrieveResponse,
    learningData,
    'IntroLearningPage',
  )

  return (
    <>
      <SimpleAccordion id="showIntroPageAccordion" defaultActiveKey={['1']}>
        <SimpleAccordion.Panel
          header="Quick-Start Intro"
          eventKey="1"
          noCollapse
        >
          <PanelSpecialIndent>
            <UniversalLoader
              show={isLoading}
              content="Loading learning content..."
            />
            {isError && (
              <div>
                Error:{' '}
                {error instanceof Error
                  ? error.message
                  : 'Failed to load learning content'}
              </div>
            )}
            {!isLoading && !isError && validatedData?.data?.intro && (
              <div
                dangerouslySetInnerHTML={{ __html: validatedData.data.intro }}
              />
            )}
            {!isLoading && !isError && !validatedData?.data?.intro && (
              <div>
                <h3>Welcome to Citrus Learning</h3>

                {validatedData && (
                  <p>API Status: {validatedData.status || 'success'}</p>
                )}
              </div>
            )}
          </PanelSpecialIndent>
        </SimpleAccordion.Panel>
      </SimpleAccordion>
    </>
  )
}

export default IntroLearningPage
